<template>
  <v-dialog 
    v-model="navigation.CRMWhatsappConversationNoteDialogIsVisible" 
    @update:model-value="navigation.CRMWhatsappConversationNoteDialogIsVisible == false ? closeCRMWhatsappConversationNoteDialog() : null" 
    max-width="80vw" 
    style="user-select: none; cursor: default;"
  >
    <v-card style="max-height: 90vh; display: flex; flex-direction: column;">
      <div style="position: sticky; top: 0; z-index: 10; background: white;">
        <v-card color="primary" rounded="0" elevation="0" class="headerCard">
          <div class="titleContainer">
            <v-icon color="indigo" size="large">mdi-note</v-icon>
            <h3>NOTAS DE LA CONVERSACIÓN</h3>
          </div>
          <div class="actionsContainer">
            <template v-if="display.CRMWhatsappConversation">
              <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID)">
                <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == display.CRMWhatsappConversation.CRMWhatsappConversationCurrentCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                  </div>
                </v-chip>
              </template>
              <template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <p>No registrado</p>
                  </div>
                </v-chip>
              </template>
            </template>
            <v-btn 
              @click="closeCRMWhatsappConversationNoteDialog()"
              :disabled="loader.selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog"
              color="error" 
              class="hoverableText" 
            >
              <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
              <p>CERRAR</p>
            </v-btn>
          </div>
        </v-card>
        <v-card color="indigo" elevation="0" rounded="0" style="width: 100%; height: 2px;"></v-card>
      </div>
      <div style="flex: 1; overflow-y: auto;">
        <div v-if="display.CRMWhatsappConversation" class="dataContainer">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-barcode</v-icon>
              <p><strong>ID: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappConversationID || 'No registrado' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-card-account-details</v-icon>
              <p><strong>SSN: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappContactSSN || 'No registrado' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-account</v-icon>
              <p><strong>Nombre: </strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(display.CRMWhatsappConversation) }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-phone</v-icon>
              <p><strong>Teléfono: </strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(display.CRMWhatsappConversation.CRMWhatsappContactPhoneNumber) }}</p>
            </div>
          </div>
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-email</v-icon>
              <p><strong>Correo electrónico: </strong>{{ display.CRMWhatsappConversation.CRMWhatsappContactEmail || 'No registrado' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-store</v-icon>
              <p style="margin-right: 5px;"><strong>Localidad: </strong></p>
              <template v-if="display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID && systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID)">
                <v-chip :color="systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID).CRMLocalityColor || 'primary'" variant="flat" elevation="2" label>
                  <p>{{ systemInformationData.CRMLocalities.find((CRMLocality) => CRMLocality.CRMLocalityID == display.CRMWhatsappConversation.CRMWhatsappContactCRMLocalityID).CRMLocalityName || 'No registrada' }}</p>
                </v-chip>
              </template>
              <template v-else>
                <v-chip color="primary" variant="flat" elevation="2" label>
                  <p>No registrada</p>
                </v-chip>
              </template>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-calendar-start</v-icon>
              <p><strong>Primera orden: </strong>{{ display.CRMWhatsappConversation.firstCRMWhatsappInvoiceCreationDatetime ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappConversation.firstCRMWhatsappInvoiceCreationDatetime) : 'No registrada' }}</p>
            </div>
            <div style="display: flex; gap: 5px; align-items: center;">
              <v-icon color="indigo">mdi-calendar-end</v-icon>
              <p><strong>Última orden: </strong>{{ display.CRMWhatsappConversation.lastCRMWhatsappInvoiceCreationDatetime ? $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(display.CRMWhatsappConversation.lastCRMWhatsappInvoiceCreationDatetime) : 'No registrada' }}</p>
            </div>
          </div>
        </div>
        <v-card color="borderInner" elevation="0" rounded="0" style="width: 100%; height: 1px;"></v-card>
        <v-data-table 
          :headers="display.CRMWhatsappConversationNoteHeaders" 
          :items="computed_sortedCRMWhatsappConversationNote" 
          :items-per-page="display.CRMWhatsappConversationNote.length > 50 ? 50 : -1"
          :loading="loader.selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog"
          hover
          fixed-header
          style="max-height: 500px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;"
        >
          <template v-slot:header.CRMWhatsappConversationNoteID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon color="indigo">mdi-barcode</v-icon>
              <p><strong>ID</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationNoteContent>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon color="indigo">mdi-alphabetical-variant</v-icon>
              <p><strong>CONTENIDO</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationNoteCreationCRMAgentID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon color="indigo">mdi-account-arrow-right</v-icon>
              <p><strong>CREACIÓN</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationNoteUpdateCRMAgentID>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon color="indigo">mdi-account-arrow-left</v-icon>
              <p><strong>ACTUALIZACIÓN</strong></p>
            </div>
          </template>
          <template v-slot:header.CRMWhatsappConversationNotePriority>
            <div style="display: flex; align-items: center; white-space: nowrap; gap: 5px;">
              <v-icon color="indigo">mdi-alert-circle</v-icon>
              <p><strong>PRIORIDAD</strong></p>
            </div>
          </template>
          <template v-slot:item="row">
            <tr 
              v-if="row.item.CRMWhatsappConversationNoteID == null" 
              :class="loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog ? 'loadingVDataTableRow' : ''" 
              :style="computed_updateMode ? 'display: none;' : ''"
            >
              <td colspan="4">
                <v-textarea 
                  v-model="input.CRMWhatsappConversationNoteContent" 
                  ref="CRMWhatsappConversationNoteContent"
                  @click:prepend-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappConversationNoteContent'); input.CRMWhatsappConversationNoteContent = null;" 
                  :prepend-inner-icon="input.CRMWhatsappConversationNoteContent && /\S/.test(input.CRMWhatsappConversationNoteContent) ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
                  :disabled="loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog || loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog"
                  label="Contenido de la nota" 
                  variant="solo-filled" 
                  density="compact"
                  autocomplete="off"
                  rows="3"
                  max-rows="5"
                  auto-grow
                  hide-details
                  style="margin: 10px 0;"
                ></v-textarea>
              </td>
              <td colspan="2">
                <v-switch
                  v-model="input.CRMWhatsappConversationNotePriority"
                  :disabled="computed_updateMode || loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog || loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog"
                  color="indigo"
                  class="hoverableText"
                  hide-details
                ></v-switch>
              </td>
              <td>
                <v-tooltip :disabled="validateInputForCRMWhatsappConversationNoteDialog(false).success" location="top"> 
                  <template v-slot:activator="{ props }">
                    <div v-bind="props">
                      <v-btn 
                        @click="insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog()" 
                        :disabled="!validateInputForCRMWhatsappConversationNoteDialog(false).success || loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog || loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog" 
                        color="success"
                        class="hoverableText"
                      >
                        <v-icon style="margin-right: 10px;">mdi-plus-circle</v-icon>
                        <p>AGREGAR NOTA</p>
                      </v-btn>
                    </div>
                  </template>
                  <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappConversationNoteDialog(false).result }}</span>
                </v-tooltip>
              </td>
            </tr>
            <tr 
              v-else 
              :class="row.item.loading ? 'loadingVDataTableRow' : (loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog || loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || (computed_updateMode && navigation.updatingCRMWhatsappConversationNoteID != row.item.CRMWhatsappConversationNoteID) ? 'bluredVDataTableRow' : '')"
            >
              <td>
                <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID al portapapeles" location="top">
                  <template v-slot:activator="{ props }">
                    <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la nota de la conversación', 'o', row.item.CRMWhatsappConversationNoteID)" class="hoverableElement" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappConversationNoteID }}</strong></p>
                  </template>
                </v-tooltip>
              </td>
              <td v-if="row.item.updateMode" colspan="4">
                <v-textarea 
                  v-model="input.CRMWhatsappConversationNoteContent" 
                  :ref="`${row.item.CRMWhatsappConversationNoteID}_CRMWhatsappConversationNoteContent`"
                  @click:prepend-inner="$generalFunctions.default.blurInput(this, `${row.item.CRMWhatsappConversationNoteID}_CRMWhatsappConversationNoteContent`); input.CRMWhatsappConversationNoteContent = null;" 
                  :prepend-inner-icon="input.CRMWhatsappConversationNoteContent && /\S/.test(input.CRMWhatsappConversationNoteContent) ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
                  :disabled="loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog || loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog"
                  label="Contenido de la nota" 
                  variant="solo-filled" 
                  density="compact"
                  autocomplete="off"
                  rows="3"
                  max-rows="5"
                  auto-grow
                  hide-details
                  style="margin: 10px 0;"
                ></v-textarea>
              </td>
              <td v-if="!row.item.updateMode">
                <p style="max-width: 300px;">{{ row.item.CRMWhatsappConversationNoteContent }}</p>
              </td>
              <td v-if="!row.item.updateMode">
                <v-chip 
                  v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationNoteCreationCRMAgentID)" 
                  :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationNoteCreationCRMAgentID).CRMAgentColor || 'primary'" 
                  variant="flat"
                  elevation="2"
                  label
                >
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationNoteCreationCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <div style="display: flex; flex-direction: column;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationNoteCreationCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                      <div style="display: flex; align-items: center; gap: 5px;">
                        <v-icon size="x-small">mdi-clock</v-icon>
                        <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationNoteCreationDatetime) }}</p>
                      </div>
                    </div>
                  </div>
                </v-chip>
                <v-chip 
                  v-else-if="row.item.CRMWhatsappConversationNoteCreationCRMAgentName" 
                  :color="row.item.CRMWhatsappConversationNoteCreationCRMAgentColor || 'primary'" 
                  variant="flat" 
                  elevation="2"
                  label
                >
                  <div style="display: flex; align-items: center;">
                    <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <div style="display: flex; flex-direction: column;">
                      <p>{{ row.item.CRMWhatsappConversationNoteCreationCRMAgentName || 'No registrado' }}</p>
                      <div style="display: flex; align-items: center; gap: 5px;">
                        <v-icon size="x-small">mdi-clock</v-icon>
                        <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationNoteCreationDatetime) }}</p>
                      </div>
                    </div>
                  </div>
                </v-chip>
                <v-chip v-else color="primary" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <div style="display: flex; flex-direction: column;">
                      <p>No registrado</p>
                      <div style="display: flex; align-items: center; gap: 5px;">
                        <v-icon size="x-small">mdi-clock</v-icon>
                        <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationNoteCreationDatetime) }}</p>
                      </div>
                    </div>
                  </div>
                </v-chip>
              </td>
              <td v-if="!row.item.updateMode">
                <v-chip 
                  v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationNoteUpdateCRMAgentID)" 
                  :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationNoteUpdateCRMAgentID).CRMAgentColor || 'primary'" 
                  variant="flat"
                  elevation="2"
                  label
                >
                  <div style="display: flex; align-items: center;">
                    <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationNoteUpdateCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <div style="display: flex; flex-direction: column;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappConversationNoteUpdateCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                      <div style="display: flex; align-items: center; gap: 5px;">
                        <v-icon size="x-small">mdi-clock</v-icon>
                        <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationNoteUpdateDatetime) }}</p>
                      </div>
                    </div>
                  </div>
                </v-chip>
                <v-chip v-else color="primary" variant="flat" elevation="2" label>
                  <div style="display: flex; align-items: center;">
                    <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                    <div style="display: flex; flex-direction: column;">
                      <p>No registrado</p>
                      <div style="display: flex; align-items: center; gap: 5px;">
                        <v-icon size="x-small">mdi-clock</v-icon>
                        <p style="font-size: x-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationNoteUpdateDatetime) }}</p>
                      </div>
                    </div>
                  </div>
                </v-chip>
              </td>
              <td v-if="!row.item.updateMode">
                <v-switch 
                  @click="updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog(row.item)"
                  v-model="row.item.CRMWhatsappConversationNotePriority"
                  :disabled="computed_updateMode || loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog || loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog"
                  color="indigo"
                  class="hoverableText"
                  hide-details
                ></v-switch>
              </td>
              <td>
                <v-tooltip v-if="row.item.updateMode" :disabled="validateInputForCRMWhatsappConversationNoteDialog(false).success" location="top"> 
                  <template v-slot:activator="{ props }">
                    <div v-bind="props">
                      <v-btn 
                        @click="updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog(row.item); this.navigation.updatingCRMWhatsappConversationNoteID = null;" 
                        :disabled="!validateInputForCRMWhatsappConversationNoteDialog(false).success || loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog || loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog" 
                        color="warning"
                        class="hoverableText"
                      >
                        <v-icon style="margin-right: 10px;">mdi-update</v-icon>
                        <p>GUARDAR ACTUALIZACIÓN</p>
                      </v-btn>
                    </div>
                  </template>
                  <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappConversationNoteDialog(false).result }}</span>
                </v-tooltip>
                <v-btn
                  v-else
                  @click="row.item.updateMode = true; this.navigation.updatingCRMWhatsappConversationNoteID = row.item.CRMWhatsappConversationNoteID; this.input.CRMWhatsappConversationNoteContent = row.item.CRMWhatsappConversationNoteContent; this.$generalFunctions.default.focusInput(this, `${row.item.CRMWhatsappConversationNoteID}_CRMWhatsappConversationNoteContent`)" 
                  color="warning" 
                  class="hoverableText"
                >
                  <v-icon style="margin-right: 10px;">mdi-pencil</v-icon>
                  <p>ACTUALIZAR NOTA</p>
                </v-btn>
              </td>
              <td>
                <v-btn
                  v-if="row.item.updateMode"
                  @click="row.item.updateMode = false; this.navigation.updatingCRMWhatsappConversationNoteID = null; this.input.CRMWhatsappConversationNoteContent = null; this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationNoteContent')" 
                  :disabled="loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog || loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog || loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog"
                  color="error" 
                  class="hoverableText"
                >
                  <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
                  <p>CANCELAR ACTUALIZACIÓN</p>
                </v-btn>
                <v-btn 
                  v-else
                  @click="deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog(row.item); this.navigation.updatingCRMWhatsappConversationNoteID = null;" 
                  color="error" 
                  class="hoverableText"
                >
                  <v-icon style="margin-right: 10px;">mdi-delete</v-icon>
                  <p>ELIMINAR NOTA</p>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:bottom v-if="display.CRMWhatsappConversationNote.length <= 50"></template>
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>


<style scoped>
  .headerCard {
    padding: 15px;
    display: grid;
    justify-content: center;
    align-items: center;
    gap: 10px;
    grid-template-columns: repeat(2, 1fr);
  }
  
  .titleContainer {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .dataContainer {
    padding: 15px;
    gap: 10px;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1200px) {
    .headerCard {
      grid-template-columns: repeat(1, 1fr);
    }

    .titleContainer {
      justify-content: center;
    }

    .actionsContainer {
      justify-content: center;
      margin-left: 0;
    }

    .dataContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>


<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import websocket from '@/utilities/websocket';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input: 
      {
        CRMWhatsappConversationNoteContent: null,
        CRMWhatsappConversationNotePriority: false
      },
      display: 
      {
        CRMWhatsappConversation: null,
        CRMWhatsappConversationNote: [],
        CRMWhatsappConversationNoteHeaders:
        [
          {title: 'ID', value: 'CRMWhatsappConversationNoteID', sortable: false},
          {title: 'CONTENIDO', value: 'CRMWhatsappConversationNoteContent', sortable: false},
          {title: 'CREACIÓN', value: 'CRMWhatsappConversationNoteCreationCRMAgentID', sortable: false},
          {title: 'ACTUALIZACIÓN', value: 'CRMWhatsappConversationNoteUpdateCRMAgentID', sortable: false},
          {title: 'PRIORIDAD', value: 'CRMWhatsappConversationNotePriority', sortable: false},
          {title: null, value: 'CRMWhatsappConversationInsertOrUpdateAction', sortable: false},
          {title: null, value: 'CRMWhatsappConversationDeleteAction', sortable: false}
        ],
      },
      navigation: 
      {
        updatingCRMWhatsappConversationNoteID: null,
        CRMWhatsappConversationID: null,
        CRMWhatsappConversationNoteDialogIsVisible: false,
      },
      loader: 
      {
        selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog: false,
        insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog: false,
        updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog: false,
        updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog: false,
        deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog: false
      },
      websocketCallback:
      {
        insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog: null,
        updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog: null,
        updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog: null,
        deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: [],
        CRMLocalities: [],
        tooltipDisabled: false,
        updateSubscription: null
      },
    }),

    computed:
    {
      computed_updateMode(){
        return this.display.CRMWhatsappConversationNote.some(CRMWhatsappConversationNote => CRMWhatsappConversationNote.updateMode);
      },

      computed_sortedCRMWhatsappConversationNote(){
        return this.display.CRMWhatsappConversationNote.slice().sort((A, B) => {
          if (A.CRMWhatsappConversationNoteID == null && B.CRMWhatsappConversationNoteID != null) return -1;
          if (A.CRMWhatsappConversationNoteID != null && B.CRMWhatsappConversationNoteID == null) return 1;
          if (A.CRMWhatsappConversationNotePriority && !B.CRMWhatsappConversationNotePriority) return -1;
          if (!A.CRMWhatsappConversationNotePriority && B.CRMWhatsappConversationNotePriority) return 1;
          if (A.CRMWhatsappConversationNoteID != null && B.CRMWhatsappConversationNoteID != null) return B.CRMWhatsappConversationNoteID - A.CRMWhatsappConversationNoteID;
          return 0;
        });
      }
    },

    methods:
    {
      async insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog(){
        this.loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = true;
        const insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
          'CRMWhatsappConversationNoteContent': this.input.CRMWhatsappConversationNoteContent,
          'CRMWhatsappConversationNotePriority': this.input.CRMWhatsappConversationNotePriority
        };
        const insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogRequestQuery);
        if (insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult.success){
          const insertedCRMWhatsappConversationNote = 
          {
            'CRMWhatsappConversationNoteID': insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult.result.CRMWhatsappConversationNoteID,
            'CRMWhatsappConversationNoteContent': this.input.CRMWhatsappConversationNoteContent,
            'CRMWhatsappConversationNotePriority': this.input.CRMWhatsappConversationNotePriority,
            'CRMWhatsappConversationNoteCreationDatetime': new Date(),
            'CRMWhatsappConversationNoteCreationCRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID,
            'CRMWhatsappConversationNoteUpdateDatetime': new Date(),
            'CRMWhatsappConversationNoteUpdateCRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID,
            'updateMode': false,
            'loading': false
          };
          this.display.CRMWhatsappConversationNote = 
          [
            insertedCRMWhatsappConversationNote,
            ...this.display.CRMWhatsappConversationNote
          ];
          this.input.CRMWhatsappConversationNoteContent = null;
          this.input.CRMWhatsappConversationNotePriority = false;
          this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationNoteContent');
          this.$root.notificationDialog.showSystemNotificationDialog(`CRMWhatsappConversationNoteDialog_insertCRMWhatsappConversationNote${insertedCRMWhatsappConversationNote.CRMWhatsappConversationNoteID}_FromCRMWhatsappConversationNoteDialog_success`, 'success', `Se ha agregado la nota ${insertedCRMWhatsappConversationNote.CRMWhatsappConversationNoteID} a la conversación`, null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationNoteDialog_insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog_error', 'error', 'Ha ocurrido un error inesperado al agregar la nota a la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = false;
      },

      async updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog(CRMWhatsappConversationNote){
        CRMWhatsappConversationNote.loading = true;
        this.loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = true;
        const updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
          'CRMWhatsappConversationNoteID': CRMWhatsappConversationNote.CRMWhatsappConversationNoteID,
          'CRMWhatsappConversationNoteContent': this.input.CRMWhatsappConversationNoteContent
        };
        const updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogRequestQuery);
        if (updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult.success){          
          CRMWhatsappConversationNote.CRMWhatsappConversationNoteContent = this.input.CRMWhatsappConversationNoteContent;
          CRMWhatsappConversationNote.CRMWhatsappConversationNoteUpdateDatetime = new Date();
          CRMWhatsappConversationNote.CRMWhatsappConversationNoteUpdateCRMAgentID = this.systemInformationData.CRMAgent.CRMAgentID;
          CRMWhatsappConversationNote.updateMode = false;
          this.input.CRMWhatsappConversationNoteContent = null;
          this.$root.notificationDialog.showSystemNotificationDialog(`CRMWhatsappConversationNoteDialog_updateCRMWhatsappConversationNote${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID}_FromCRMWhatsappConversationNoteDialog_success`, 'success', `Se ha actualizado la nota ${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID} de la conversación`, null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationNoteDialog_updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog_error', 'error', `Ha ocurrido un error inesperado al actualizar la nota ${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID} de la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        CRMWhatsappConversationNote.loading = false;
        this.loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = false;
      },

      async updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog(CRMWhatsappConversationNote){
        CRMWhatsappConversationNote.loading = true;
        this.loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog = true;
        const updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
          'CRMWhatsappConversationNoteID': CRMWhatsappConversationNote.CRMWhatsappConversationNoteID,
          'CRMWhatsappConversationNoteCreationCRMAgentID': CRMWhatsappConversationNote.CRMWhatsappConversationNoteCreationCRMAgentID,
          'CRMWhatsappConversationNotePriority': !CRMWhatsappConversationNote.CRMWhatsappConversationNotePriority
        };
        const updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog', updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialogRequestQuery);
        if (updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialogResult.success){
          CRMWhatsappConversationNote.CRMWhatsappConversationNotePriority = !CRMWhatsappConversationNote.CRMWhatsappConversationNotePriority;
          CRMWhatsappConversationNote.CRMWhatsappConversationNoteUpdateDatetime = new Date();
          CRMWhatsappConversationNote.CRMWhatsappConversationNoteUpdateCRMAgentID = this.systemInformationData.CRMAgent.CRMAgentID;
          this.$root.notificationDialog.showSystemNotificationDialog(`CRMWhatsappConversationNoteDialog_updateCRMWhatsappConversationNotePriority${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID}_FromCRMWhatsappConversationNoteDialog_success`, 'success', `Se ha actualizado la prioridad de la nota ${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID} de la conversación`, null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationNoteDialog_updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog_error', 'error', `Ha ocurrido un error inesperado al actualizar la prioridad de la nota ${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID} de la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        CRMWhatsappConversationNote.loading = false;
        this.loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog = false;
      },

      async deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog(CRMWhatsappConversationNote){
        this.loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = true;
        CRMWhatsappConversationNote.loading = true;
        const deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID,
          'CRMWhatsappConversationNoteID': CRMWhatsappConversationNote.CRMWhatsappConversationNoteID,
          'CRMWhatsappConversationNoteCreationCRMAgentID': CRMWhatsappConversationNote.CRMWhatsappConversationNoteCreationCRMAgentID,
          'CRMWhatsappConversationNotePriority': CRMWhatsappConversationNote.CRMWhatsappConversationNotePriority
        };
        const deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogRequestQuery);
        if (deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult.success){
          this.display.CRMWhatsappConversationNote = this.display.CRMWhatsappConversationNote.filter(displayCRMWhatsappConversationNote => displayCRMWhatsappConversationNote.CRMWhatsappConversationNoteID != CRMWhatsappConversationNote.CRMWhatsappConversationNoteID);
          this.$root.notificationDialog.showSystemNotificationDialog(`CRMWhatsappConversationNoteDialog_deleteCRMWhatsappConversationNote${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID}_FromCRMWhatsappConversationNoteDialog_success`, 'success', `Se ha eliminado la nota ${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID} de la conversación`, null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationNoteDialog_deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog_error', 'error', `Ha ocurrido un error inesperado al eliminar la nota ${CRMWhatsappConversationNote.CRMWhatsappConversationNoteID} de la conversación, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationNoteContent');
        this.loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = false;
      },

      async selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog(){
        const selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversationID
        };
        const selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogRequestQuery);
        if (selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult.success){
          this.display.CRMWhatsappConversation = selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult.result.CRMWhatsappConversation;
          this.display.CRMWhatsappConversationNote = 
          [
            {'CRMWhatsappConversationNoteID': null, 'updateMode': false, 'loading': false},
            ...selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialogResult.result.CRMWhatsappConversationNote.map(CRMWhatsappConversationNote => ({...CRMWhatsappConversationNote, 'updateMode': false, 'loading': false}))
          ];
          this.loader.selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = false;
          this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationNoteContent');
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactFollowupHistoryDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeCRMWhatsappConversationNoteDialog();
        }
      },

      validateInputForCRMWhatsappConversationNoteDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.input.CRMWhatsappConversationNoteContent == null || !regularExpressionChecker.test(this.input.CRMWhatsappConversationNoteContent)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationNoteDialog_validateInputForCRMWhatsappConversationNoteDialog_missingCRMWhatsappConversationNoteContent', 'info', 'El contenido de la nota de la conversación es obligatorio', null, false);
          return {success: false, result: 'El contenido de la nota de la conversación es obligatorio'};
        }
        else if (this.input.CRMWhatsappConversationNoteContent.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappConversationNoteDialog_validateInputForCRMWhatsappConversationNoteDialog_CRMWhatsappConversationNoteContentTooLong', 'info', 'El contenido de la nota de la conversación no puede exceder los 65535 caracteres', null, false);
          return {success: false, result: 'El contenido de la nota de la conversación no puede exceder los 65535 caracteres'};
        }
        return {success: true, result: null};
      },

      connectWebsocket(){
        websocket.connectWebsocket();
        this.websocketCallback.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = async (websocketMessageData) => {
          if (this.navigation.CRMWhatsappConversationID == websocketMessageData.websocketMessageContent.CRMWhatsappConversationID){
            if (this.systemInformationData.CRMAgent.CRMAgentID != websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteCreationCRMAgentID){
              this.display.CRMWhatsappConversationNote = this.display.CRMWhatsappConversationNote.filter(CRMWhatsappConversationNote => CRMWhatsappConversationNote.CRMWhatsappConversationNoteID != websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteID);
              this.display.CRMWhatsappConversationNote = 
              [
                websocketMessageData.websocketMessageContent,
                ...this.display.CRMWhatsappConversationNote
              ];
              this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationNoteContent');
            }
          }
        };
        this.websocketCallback.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = async (websocketMessageData) => {
          if (this.navigation.CRMWhatsappConversationID == websocketMessageData.websocketMessageContent.CRMWhatsappConversationID){
            if (this.systemInformationData.CRMAgent.CRMAgentID != websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteUpdateCRMAgentID){
              const updatedCRMWhatsappConversationNote = this.display.CRMWhatsappConversationNote.find(CRMWhatsappConversationNote => CRMWhatsappConversationNote.CRMWhatsappConversationNoteID == websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteID);
              if (updatedCRMWhatsappConversationNote){
                updatedCRMWhatsappConversationNote.CRMWhatsappConversationNoteContent = websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteContent;
                updatedCRMWhatsappConversationNote.CRMWhatsappConversationNoteUpdateDatetime = websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteUpdateDatetime;
                updatedCRMWhatsappConversationNote.CRMWhatsappConversationNoteUpdateCRMAgentID = websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteUpdateCRMAgentID;
                const updatingCRMWhatsappConversationNote = this.display.CRMWhatsappConversationNote.find(CRMWhatsappConversationNote => CRMWhatsappConversationNote.updateMode);
                if (updatingCRMWhatsappConversationNote && updatingCRMWhatsappConversationNote.CRMWhatsappConversationNoteID == updatedCRMWhatsappConversationNote.CRMWhatsappConversationNoteID){
                  updatingCRMWhatsappConversationNote.updateMode = false;
                  this.input.CRMWhatsappConversationNoteContent = null;
                  this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationNoteContent');
                }
              }
            }
          }
        };
        this.websocketCallback.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog = async (websocketMessageData) => {
          if (this.navigation.CRMWhatsappConversationID == websocketMessageData.websocketMessageContent.CRMWhatsappConversationID){
            const updatedCRMWhatsappConversationNote = this.display.CRMWhatsappConversationNote.find(CRMWhatsappConversationNote => CRMWhatsappConversationNote.CRMWhatsappConversationNoteID == websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteID);
            if (this.systemInformationData.CRMAgent.CRMAgentID != websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteUpdateCRMAgentID){
              if (updatedCRMWhatsappConversationNote){
                updatedCRMWhatsappConversationNote.CRMWhatsappConversationNotePriority = websocketMessageData.websocketMessageContent.CRMWhatsappConversationNotePriority;
                updatedCRMWhatsappConversationNote.CRMWhatsappConversationNoteUpdateDatetime = websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteUpdateDatetime;
                updatedCRMWhatsappConversationNote.CRMWhatsappConversationNoteUpdateCRMAgentID = websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteUpdateCRMAgentID;
              }
            }
          }
        };
        this.websocketCallback.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = async (websocketMessageData) => {
          if (this.navigation.CRMWhatsappConversationID == websocketMessageData.websocketMessageContent.CRMWhatsappConversationID){
            const deletedCRMWhatsappConversationNote = this.display.CRMWhatsappConversationNote.find(CRMWhatsappConversationNote => CRMWhatsappConversationNote.CRMWhatsappConversationNoteID == websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteID);
            if (deletedCRMWhatsappConversationNote){
              if (this.systemInformationData.CRMAgent.CRMAgentID != websocketMessageData.websocketMessageContent.CRMWhatsappConversationNoteUpdateCRMAgentID){
                const updatingCRMWhatsappConversationNote = this.display.CRMWhatsappConversationNote.find(CRMWhatsappConversationNote => CRMWhatsappConversationNote.updateMode);
                if (updatingCRMWhatsappConversationNote && updatingCRMWhatsappConversationNote.CRMWhatsappConversationNoteID == deletedCRMWhatsappConversationNote.CRMWhatsappConversationNoteID){
                  this.input.CRMWhatsappConversationNoteContent = null;
                  this.$generalFunctions.default.focusInput(this, 'CRMWhatsappConversationNoteContent');
                }
                this.display.CRMWhatsappConversationNote = this.display.CRMWhatsappConversationNote.filter(CRMWhatsappConversationNote => CRMWhatsappConversationNote.CRMWhatsappConversationNoteID != deletedCRMWhatsappConversationNote.CRMWhatsappConversationNoteID);
              }
            }
          }
        };        
        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', this.websocketCallback.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog);
        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', this.websocketCallback.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog);
        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog', this.websocketCallback.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog);
        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', this.websocketCallback.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog);
      },

      disconnectWebsocket(){
        if (this.websocketCallback.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog) websocket.removeWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', this.websocketCallback.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog);
        if (this.websocketCallback.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog) websocket.removeWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', this.websocketCallback.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog);
        if (this.websocketCallback.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog) websocket.removeWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog', this.websocketCallback.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog);
        if (this.websocketCallback.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog) websocket.removeWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationNote/functions/deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog', this.websocketCallback.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog);
        this.websocketCallback.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = null;
        this.websocketCallback.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = null;
        this.websocketCallback.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog = null;
        this.websocketCallback.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = null;
      },

      async getSystemInformationData(){
        this.loader.selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactFollowupHistoryDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeCRMWhatsappConversationNoteDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactFollowupHistoryDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappConversationNoteDialog();
        }
      },
      
      async openCRMWhatsappConversationNoteDialog(CRMWhatsappContactID, CRMWhatsappConversationID, CRMWhatsappConversationNotePriority){
        await this.getSystemInformationData();
        this.connectWebsocket();
        this.input.CRMWhatsappConversationNoteContent = null;
        this.input.CRMWhatsappConversationNotePriority = CRMWhatsappConversationNotePriority;
        this.display.CRMWhatsappConversation = null;
        this.display.CRMWhatsappConversationNote.length = 0;
        this.loader.insertCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = false;
        this.loader.updateCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = false;
        this.loader.updateCRMWhatsappConversationNotePriorityFromCRMWhatsappConversationNoteDialog = false;
        this.loader.deleteCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog = false;
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.updatingCRMWhatsappConversationNoteID = null;
        this.navigation.CRMWhatsappConversationID = CRMWhatsappConversationID;
        this.navigation.CRMWhatsappConversationNoteDialogIsVisible = true;
        this.selectCRMWhatsappConversationNoteFromCRMWhatsappConversationNoteDialog();
      },

      closeCRMWhatsappConversationNoteDialog(){
        this.navigation.CRMWhatsappConversationNoteDialogIsVisible = false;
        this.disconnectWebsocket();
        this.$emit('closeCRMWhatsappConversationNoteDialog');
      }
    }
  }
</script>